import { render, staticRenderFns } from "./AnaliseVinculoTable.vue?vue&type=template&id=0ef9c5ee&scoped=true&lang=pug"
import script from "./AnaliseVinculoTable.vue?vue&type=script&lang=js"
export * from "./AnaliseVinculoTable.vue?vue&type=script&lang=js"
import style0 from "./AnaliseVinculoTable.vue?vue&type=style&index=0&id=0ef9c5ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef9c5ee",
  null
  
)

export default component.exports